module.exports = __webpack_public_path__ + "static/media/1-1-1@2x.11bf590c.png";